import { Box, Pagination, Stack } from '@mui/material';
import { IconButtonExportExcel } from 'components/iconButtons/IconButtonExportExcel';

interface IProps {
    pageNumber: number;
    totalPages: number;
    onSetPageNumber: (pagenumber: number) => void;
    onExportData?: () => void;
}

export const DashPagination = ({ pageNumber, totalPages, onSetPageNumber, onExportData }: IProps) => {
    return (
        <Stack direction="row" width="100%" sx={{ mt: 2 }}>
            <Box display="flex" flexGrow={1} justifyContent="center">
                {totalPages > 1 &&
                    <Pagination
                        shape="rounded"
                        color="primary"
                        page={pageNumber}
                        count={totalPages}
                        onChange={(e, pageNumber) => onSetPageNumber(pageNumber)}
                    />
                }
            </Box>
            {
                onExportData &&
                <IconButtonExportExcel onClick={onExportData} color="primary" />
            }
        </Stack>
    );
};
